// ARBTools doesn't support the local-aware time format placeholder "j" so we have to maintain separate 12 and 24 hour translation strings in order to support showing time in the right format

export const dateTimeFormatStringBasedOnLocale = (locale: string) => {
  return locale === "en-GB" ? "Checklist-AppointmentCard-DateTime-24Hour" : "Checklist-AppointmentCard-DateTime";
};
